import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { generalService } from '../../services/general.service';
import { Item } from '../../models/item';
import { Chofer } from '../../models/chofer';
import { MatOptionSelectionChange, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { ItemSubFamily } from '../../models/item-subfamily';
import { MatSelect } from '@angular/material/select';

@Component({
    selector: 'app-add-chofer',
    templateUrl: 'chofer-agregar.component.html',
    styleUrls: [],
    providers: [generalService]
  })

  export class ChoferAddEditComponent implements OnInit {
    private chofer :Chofer = new Chofer();;
    public title = '';
    private loacs: string;
    
    private DRIVER_ID = undefined;
    public dataChofer: any[] = [];
    
   
    public esActualizacion = false;
    public driver: Item;
    public driverForm: FormGroup;
    public btnStatus = "";
    public nombreConductorTxt = "";
    public actualizar = false;
    public tipoFiguraList :any[]=[];
    public paises: any[] = [];
    public estados: any[] = [];
    public estadosAUX: any[] = [];
    public ciudades: any[] = [];
    public ciudadesAUX: any[] = [];
    constructor(private router: Router,private formBuilder: FormBuilder,
      private _generalService: generalService,private route: ActivatedRoute,) {
      this.driver = new Item();
      this.driverForm = new FormGroup({});
      this.DRIVER_ID = this.route.snapshot.paramMap.get('id'); 
    }

    ngOnInit(){
      this.validateRoute();
      this.buildDriverForm();
      this.consultarDataDriver();
      
    }

    validateRoute() {
      if (this.DRIVER_ID === 'N') {
        this.title = 'guardado';
        this.btnStatus = "Agregar";
      }else{
        this.title = 'actualizado';
        this.btnStatus = "Actualizar";
      }
    }
    

    backward() {
      this.router.navigate(['app/chofer']);
    }

    buildDriverForm(){
      this.driverForm = this.formBuilder.group({
        // General data
        NAME: this.formBuilder.control(null, [Validators.required, Validators.minLength(3), Validators.maxLength(50)]),
        LICENSE_NUMBER: this.formBuilder.control(null, [Validators.required, Validators.maxLength(50)]),           
        RFC: this.formBuilder.control(null, [Validators.required, Validators.maxLength(50)]),
        CP: this.formBuilder.control(null, [Validators.required, Validators.maxLength(10)]),
        SUBURB: this.formBuilder.control(null, [ Validators.maxLength(50)]),
        STREET: this.formBuilder.control(null, [ Validators.maxLength(50)]),
        OUTDOOR_NUMBER: this.formBuilder.control(null, [ Validators.maxLength(50)]),
        INTERIOR_NUMBER: this.formBuilder.control(null, [ Validators.maxLength(50)]),
        REFERENCE: this.formBuilder.control(null, [ Validators.maxLength(50)]),
        pais:  this.formBuilder.control(null, [Validators.required, Validators.maxLength(50)]),
        estado: this.formBuilder.control(null, [Validators.required, Validators.maxLength(50)]),
        ciudad: this.formBuilder.control(null, [Validators.required, Validators.maxLength(50)]),
        tipoFugura:  this.formBuilder.control(null, [Validators.required, Validators.maxLength(50)]),
        id_chofer: this.formBuilder.control(null), 
      });
    }

    //msj de validacion del campo nombre
    get namechoferControl() {
      return this.driverForm.get('NAME');
    }

    consultarDataDriver(){
      let metodo = 'Driver/getDataDriver';
     
      const params = { 
          loacs: sessionStorage.getItem('acslo'),
          idchofer:this.DRIVER_ID
      };

      this._generalService.metodoCallParams(params, metodo).subscribe(
        result => {
          const tableResult = JSON.parse(result);
          this.paises = tableResult.Table; 
          this.estados = tableResult.Table1;
          this.ciudades = tableResult.Table2;
          this.dataChofer = tableResult.Table3;
          this.tipoFiguraList = tableResult.Table4;

          if (this.dataChofer.length > 0){
            this.driverForm.get('NAME').setValue(this.dataChofer[0].NAME);
            this.driverForm.get('LICENSE_NUMBER').setValue(this.dataChofer[0].LICENSE_NUMBER);
            this.driverForm.get('RFC').setValue(this.dataChofer[0].RFC);
            this.driverForm.get('CP').setValue(this.dataChofer[0].CP);
            this.driverForm.get('SUBURB').setValue(this.dataChofer[0].SUBURB);
            this.driverForm.get('STREET').setValue(this.dataChofer[0].STREET);
            this.driverForm.get('OUTDOOR_NUMBER').setValue(this.dataChofer[0].OUTDOOR_NUMBER);
            this.driverForm.get('INTERIOR_NUMBER').setValue(this.dataChofer[0].INTERIOR_NUMBER);
            this.driverForm.get('REFERENCE').setValue(this.dataChofer[0].REFERENCE);

            this.driverForm.get('pais').setValue(this.dataChofer[0].COUNTRY_ID);
            this.driverForm.get('estado').setValue(this.dataChofer[0].STATE_ID);
            this.driverForm.get('ciudad').setValue(this.dataChofer[0].CITY_ID);
            this.driverForm.get('tipoFugura').setValue(this.dataChofer[0]. SAT_FIGURE_TYPE_ID);

            this.driverForm.get('id_chofer').setValue(this.dataChofer[0].DRIVER_ID);

            this.estadosAUX = this.estados.filter((element) => element.COUNTRY_ID === this.dataChofer[0].COUNTRY_ID);
            this.ciudadesAUX = this.ciudades.filter((element) => element.STATE_ID === this.dataChofer[0].STATE_ID);

            this.nombreConductorTxt = this.dataChofer[0].NAME;
          } 
    
        },
        error => {  console.log(<any>error);  }
      );
    }



    seteraSelect(event: any, opcion: number){
      switch (opcion) {
        case 1:
          this.estadosAUX = this.estados.filter((element) => element.COUNTRY_ID === event.value);
        break;
        case 2:
          this.ciudadesAUX = this.ciudades.filter((element) => element.STATE_ID === event.value);
        break;
        default:
        break;
      }
      
    }
   
    mapearDatosFormularioEnModelo() {
      this.chofer.NAME = this.driverForm.controls['NAME'].value;
      this.chofer.LICENSE_NUMBER = this.driverForm.controls['LICENSE_NUMBER'].value;
      this.chofer.RFC = this.driverForm.controls['RFC'].value;
      this.chofer.CP = this.driverForm.controls['CP'].value;
      this.chofer.SUBURB = this.driverForm.controls['SUBURB'].value;
      this.chofer.STREET = this.driverForm.controls['STREET'].value;
      this.chofer.OUTDOOR_NUMBER = this.driverForm.controls['OUTDOOR_NUMBER'].value;
      this.chofer.INTERIOR_NUMBER = this.driverForm.controls['INTERIOR_NUMBER'].value;
      this.chofer.REFERENCE = this.driverForm.controls['REFERENCE'].value;
      this.chofer.pais = this.driverForm.controls['pais'].value;
      this.chofer.estado = this.driverForm.controls['estado'].value;
      this.chofer.ciudad = this.driverForm.controls['ciudad'].value;
      this.chofer.CITY_ID = this.driverForm.controls['ciudad'].value;
      this.chofer.SAT_FIGURE_TYPE_ID = this.driverForm.controls['tipoFugura'].value;
      this.chofer.loacs =  sessionStorage.getItem('acslo');
      
      
      //this.chofer. =this.DRIVER_ID,
      // this.chofer.DRIVER_ID = this.DRIVER_ID;
      this.chofer.DRIVER_ID = parseInt(this.DRIVER_ID, 10);

    }
    guardarDriveder(){
      this.mapearDatosFormularioEnModelo();
      this. agregarDriver();
    }
    agregarDriver() {
      this._generalService.metodoCallParams(this.chofer, 'Driver/addDriver').subscribe(
        (result) => {
          this.backward();
          this._generalService.toastCall('Registro '+ this.title +' exitosamente!');
          }, (error) => {
            console.log(error as any);
          });
    }
}


// WEBPACK FOOTER //
// ./src/app/chofer/agregar-editar/chofer-agregar.component.ts